import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : low level components on db tree data
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Framework imports
import { callIfFunc } from 'ldash';
import { Actions } from 'uix/registries';
import log from 'uix/logging';
import { TreeNode } from 'uix/types/components';
import { useState, useMemo } from 'uix/hooks';
import { hashObj } from 'uix/utils';
// ---Local imports
import { useTreeNodes, useTreeNode } from './hooks';
import styles from './styles.css';
// ---Globals
export const TreeNodeItem = ({ otid, unloaded = '...' })=>{
    /* TreeNode with data loading */ let treeNodeInfo = useTreeNode(otid);
    return treeNodeInfo ? /*#__PURE__*/ _jsx(TreeNode, {
        node: treeNodeInfo
    }) : unloaded;
};
export const TreeNodeList = ({ otids, nodes, selected: outerSelected, onSelect, annotate, style, link, linkLazy })=>{
    otids = useMemo(()=>nodes ? nodes.map((n)=>n.otid) : otids, [
        hashObj(otids),
        nodes
    ]);
    if (!nodes) {
        nodes = otids.map((otid)=>({
                otid
            }));
    }
    let data = useTreeNodes(otids);
    let [selected, setSelected] = useState(null);
    selected = outerSelected === undefined ? selected : outerSelected;
    let selectable = !!onSelect;
    let onClick = (nkey)=>{
        setSelected(nkey);
        callIfFunc(onSelect, nkey);
    };
    let renderedNodes = nodes.filter(({ otid })=>data[otid]).map(({ otid, nkey })=>{
        nkey = nkey || otid;
        return /*#__PURE__*/ _jsxs("div", {
            style: style,
            className: clsx(styles.treeListItem, selectable && styles.selectable, nkey == selected && styles.selected),
            onClick: selectable ? ()=>onClick(nkey) : null,
            children: [
                annotate ? /*#__PURE__*/ _jsx("span", {
                    style: {
                        float: 'right'
                    },
                    children: annotate({
                        otid,
                        nkey
                    })
                }) : null,
                /*#__PURE__*/ _jsx(TreeNode, {
                    node: data[otid],
                    link: link,
                    linkLazy: linkLazy
                })
            ]
        }, nkey);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.treeNodeList,
        children: renderedNodes
    });
};
export const UnresolvedTreeNode = ({ otid, placeholder = '...', ...props })=>{
    let node = useTreeNode(otid);
    return node ? /*#__PURE__*/ _jsx(TreeNode, {
        node: node,
        ...props
    }) : placeholder;
};
